import React, { useMemo } from 'react';
import { bool, object } from 'prop-types';
import styled from 'styled-components';
import { bodyLRegularUtopiaStyles, bodyMRegularUtopiaStyles } from '../../../styles/typography';
import { bpWidth, colors } from '../../../styles/variables';
import { renderRichTextReact } from '../../../utils/storyblokRichText';

const ProductDescription = styled.div`
  ${bodyLRegularUtopiaStyles};
  color: ${colors.navy600};
  padding-bottom: 40px;

  i {
    font-style: italic;
  }

  ${({ starWarsTheme }) => starWarsTheme && `color: ${colors.beige100}`};

  * {
    ${({ starWarsTheme }) => starWarsTheme && `color: ${colors.beige100}`};
  }

  @media (${bpWidth.desktopSm}) {
    ${bodyMRegularUtopiaStyles};
    color: ${colors.navy600};

    ${({ starWarsTheme }) => starWarsTheme && `color: ${colors.beige100}`};

    * {
      ${({ starWarsTheme }) => starWarsTheme && `color: ${colors.beige100}`};
    }
  }

  @media (${bpWidth.desktopSm}) {
    padding-bottom: 30px;

    ${({ starWarsTheme }) => starWarsTheme && `color: ${colors.beige100}`};

    * {
      ${({ starWarsTheme }) => starWarsTheme && `color: ${colors.beige100}`};
    }
  }
`;

const ProductVariantDescription = (props) => {
  const { currentVariant = null, starWarsTheme = false } = props;

  const variantDescription = useMemo(() => renderRichTextReact(currentVariant?.description), [currentVariant]);

  return (
    variantDescription && <ProductDescription starWarsTheme={starWarsTheme}>{variantDescription}</ProductDescription>
  );
};

ProductVariantDescription.propTypes = {
  currentVariant: object,
  starWarsTheme: bool,
};

export default ProductVariantDescription;
